module.exports = __webpack_public_path__ + "img/logo-company.05a8faa5.png";